// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1rzO_","sendOtp":"AuthorizeToLogin_sendOtp__2-3Qx"};